// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

@-webkit-keyframes fade-into {

    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0px);
    }
}

@keyframes fade-into {

    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0px);
    }
}

@-webkit-keyframes fade-grow {

    from {
        opacity: 0;
        transform: scale(0.96);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes fade-grow {

    from {
        opacity: 0;
        transform: scale(0.96);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

@-webkit-keyframes slide-up {

    from {
        transform: translateY(100%);
    }

    to {
        transform: translateY(0px);
    }
}

@keyframes slide-up {

    from {
        transform: translateY(100%);
    }

    to {
        transform: translateY(0px);
    }
}

html {
    height: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
}

body {
    color: #2d2d2d;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Open Sans", "Helvetica", "Arial", sans-serif;
    font-size: 14px;
    line-height: 22px;
    shape-rendering: crispedges;
}

body.cool {
    background-color: #f2f2f2;
}

body.cool.cool-yellow {
    background-color: #fbdb62;
}

body.cool.cool-blue {
    background-color: #2d9fc4;
}

body.cool.cool-green {
    background-color: #8dbab5;
}

body.cool.cool-grey {
    background-color: #5d5d5d;
}

body.cool.cool-gradient,
body.cool.cool-gradient-green {
    background-attachment: fixed;
    background-image: linear-gradient(to right bottom, rgba(0, 128, 128, 1) 20%, #8dbab5 100%);
}

body.cool.cool-gradient-blue {
    background-attachment: fixed;
    background-image: linear-gradient(to right bottom, #1c7591 20%, #2d9fc4 100%);
}

body.cool.cool-gradient-violet {
    background-attachment: fixed;
    background-image: linear-gradient(to right bottom, #a18cd1 0%, #fbc2eb 100%);
}

body.cool.cool-gradient-crazy {
    background-attachment: fixed;
    background-image: linear-gradient(to right top, #38438b, #944b94, #d75a88, #ff7e71, #ffb25f, #ffeb68);
}

body.center {
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 0px 16px 0px 16px;
    min-height: 100%;
    text-align: center;
}

h1 {
    font-size: 24px;
    font-weight: normal;
    line-height: 28px;
    margin: 16px 0px 16px 0px;
}

h2 {
    font-size: 15px;
    font-weight: 600;
    line-height: 18px;
    margin: 12px 0px 12px 0px;
}

body.cool h1 {
    color: #2d2d2d;
}

p {
    margin: 8px 0px 8px 0px;
}

p.extra {
    margin-top: 16px;
}

p.footer {
    bottom: 0px;
    font-size: 11px;
    font-weight: normal;
    letter-spacing: 0.3px;
    position: absolute;
}

p.footer.upper {
    color: #4d4d4d;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.2px;
    text-transform: uppercase;
}

body.cool.cool-color p.footer {
    color: #ffffff;
}

a {
    color: #4769cc;
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

a.strong,
span.strong {
    background-color: #dbe9f4;
    padding: 2px 4px 2px 4px;
}

a.button,
span.button {
    background-color: #2d9fc4;
    border-radius: 4px 4px 4px 4px;
    color: #ffffff;
    cursor: pointer;
    display: inline-block;
    font-size: 11px;
    font-weight: 600;
    height: 34px;
    letter-spacing: 1px;
    line-height: 34px;
    margin: 0px 0px 0px 0px;
    min-width: 120px;
    text-transform: uppercase;
    transition: color 0.1s linear, background-color 0.1s linear;
    user-select: none;
}

a.button:hover,
span.button:hover {
    background-color: #31acd4;
    text-decoration: none;
}

a.button:active,
span.button:active {
    background-color: #2c99bd;
}

a.button.button-small,
span.button.button-small {
    font-size: 10px;
    height: 30px;
    line-height: 30px;
}

a.button.button-green,
span.button.button-green {
    background-color: #64a280;
}

a.button.button-grey,
span.button.button-grey {
    background-color: #2d2d2d;
}

a.button.button-grey:hover,
span.button.button-grey:hover {
    background-color: #4d4d4d;
}

a.button.button-grey:active,
span.button.button-grey:active {
    background-color: #1d1d1d;
}

a.button.button-transparent,
span.button.button-transparent {
    background-color: transparent;
    border: 1px solid #ffffff;
}

a.button-transparent:hover,
span.button-transparent:hover {
    background-color: rgba(255, 255, 255, 0.3);
}

a.button-transparent:active,
span.button-transparent:active {
    background-color: rgba(255, 255, 255, 0.5);
}

hr {
    margin: 3px 0px 3px 0px;
}

table {
    font-size: 13px;
    line-height: 18px;
    max-width: 760px;
    table-layout: fixed;
    word-break: break-all;
}

table th {
    font-weight: 600;
}

table th > *,
table td > * {
    vertical-align: middle;
}

table th > a {
    color: #2d2d2d;
}

table th > a.selected {
    font-weight: bold;
    text-decoration: underline;
}

table td > svg {
    color: #4d4d4d;
    fill: currentcolor;
    margin-right: 6px;
}

.buttons {
    margin: 16px 0px 16px 0px;
}

.highlight {
    font-size: 16px;
    font-weight: 600;
    margin: 12px 0px 12px 0px;
}

.highlight > a {
    background: #f4f4f4;
    box-shadow: 1px 1px 4px rgba(80, 80, 80, 0.35);
    display: inline-block;
    padding: 8px 16px 8px 16px;
}

.traceback {
    line-height: 26px;
    margin: 8px 0px 8px 0px;
}

.container {
    animation: fade-into 0.75s ease-in-out;
    width: 100%;
}

body.cool .container {
    animation: fade-grow 0.5s ease-in-out;
    background-color: #ffffff;
    border: 1px solid #d4d4d4;
    border-radius: 4px 4px 4px 4px;
    box-shadow: 0px 0px 3px #e4e4e4;
    margin: 12px auto 12px auto;
    padding: 24px 42px 24px 42px;
    width: auto;
}

body.cool .container.dynamic {
    padding: 24px 0px 24px 0px;
    width: 100%;
}

body.cool.cool-color .container {
    background-color: #fefefe;
    border: none;
    box-shadow: 0px 0px 24px rgba(10, 10, 10, 0.4);
}

.container img.logo {
    max-height: 128px;
    max-width: 128px;
}

@media screen and (max-width: 760px) {

    table th,
    table td {
        display: none;
    }

    table td:nth-child(1) {
        display: initial;
    }

    body.cool .container {
        padding: 12px 12px 12px 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/layout.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;;IAEI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,0BAA0B;IAC9B;AACJ;;AAEA;;IAEI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,0BAA0B;IAC9B;AACJ;;AAEA;;IAEI;QACI,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;QACI,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;;IAEI;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,YAAY;IACZ,wDAAwD;AAC5D;;AAEA;IACI,cAAc;IACd,mHAAmH;IACnH,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,4BAA4B;IAC5B,0FAA0F;AAC9F;;AAEA;IACI,4BAA4B;IAC5B,6EAA6E;AACjF;;AAEA;IACI,4BAA4B;IAC5B,4EAA4E;AAChF;;AAEA;IACI,4BAA4B;IAC5B,qGAAqG;AACzG;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;;IAEI,yBAAyB;IACzB,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,2DAA2D;IAC3D,iBAAiB;AACrB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,yBAAyB;IACzB,8BAA8B;IAC9B,+BAA+B;IAC/B,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI;;QAEI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":["@charset \"utf-8\";\r\n\r\n@-webkit-keyframes fade-into {\r\n\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(30px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0px);\r\n    }\r\n}\r\n\r\n@keyframes fade-into {\r\n\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(30px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0px);\r\n    }\r\n}\r\n\r\n@-webkit-keyframes fade-grow {\r\n\r\n    from {\r\n        opacity: 0;\r\n        transform: scale(0.96);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n@keyframes fade-grow {\r\n\r\n    from {\r\n        opacity: 0;\r\n        transform: scale(0.96);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n@-webkit-keyframes slide-up {\r\n\r\n    from {\r\n        transform: translateY(100%);\r\n    }\r\n\r\n    to {\r\n        transform: translateY(0px);\r\n    }\r\n}\r\n\r\n@keyframes slide-up {\r\n\r\n    from {\r\n        transform: translateY(100%);\r\n    }\r\n\r\n    to {\r\n        transform: translateY(0px);\r\n    }\r\n}\r\n\r\nhtml {\r\n    height: 100%;\r\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;\r\n}\r\n\r\nbody {\r\n    color: #2d2d2d;\r\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Open Sans\", \"Helvetica\", \"Arial\", sans-serif;\r\n    font-size: 14px;\r\n    line-height: 22px;\r\n    shape-rendering: crispedges;\r\n}\r\n\r\nbody.cool {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\nbody.cool.cool-yellow {\r\n    background-color: #fbdb62;\r\n}\r\n\r\nbody.cool.cool-blue {\r\n    background-color: #2d9fc4;\r\n}\r\n\r\nbody.cool.cool-green {\r\n    background-color: #8dbab5;\r\n}\r\n\r\nbody.cool.cool-grey {\r\n    background-color: #5d5d5d;\r\n}\r\n\r\nbody.cool.cool-gradient,\r\nbody.cool.cool-gradient-green {\r\n    background-attachment: fixed;\r\n    background-image: linear-gradient(to right bottom, rgba(0, 128, 128, 1) 20%, #8dbab5 100%);\r\n}\r\n\r\nbody.cool.cool-gradient-blue {\r\n    background-attachment: fixed;\r\n    background-image: linear-gradient(to right bottom, #1c7591 20%, #2d9fc4 100%);\r\n}\r\n\r\nbody.cool.cool-gradient-violet {\r\n    background-attachment: fixed;\r\n    background-image: linear-gradient(to right bottom, #a18cd1 0%, #fbc2eb 100%);\r\n}\r\n\r\nbody.cool.cool-gradient-crazy {\r\n    background-attachment: fixed;\r\n    background-image: linear-gradient(to right top, #38438b, #944b94, #d75a88, #ff7e71, #ffb25f, #ffeb68);\r\n}\r\n\r\nbody.center {\r\n    align-items: center;\r\n    display: flex;\r\n    justify-content: center;\r\n    margin: 0px 16px 0px 16px;\r\n    min-height: 100%;\r\n    text-align: center;\r\n}\r\n\r\nh1 {\r\n    font-size: 24px;\r\n    font-weight: normal;\r\n    line-height: 28px;\r\n    margin: 16px 0px 16px 0px;\r\n}\r\n\r\nh2 {\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    line-height: 18px;\r\n    margin: 12px 0px 12px 0px;\r\n}\r\n\r\nbody.cool h1 {\r\n    color: #2d2d2d;\r\n}\r\n\r\np {\r\n    margin: 8px 0px 8px 0px;\r\n}\r\n\r\np.extra {\r\n    margin-top: 16px;\r\n}\r\n\r\np.footer {\r\n    bottom: 0px;\r\n    font-size: 11px;\r\n    font-weight: normal;\r\n    letter-spacing: 0.3px;\r\n    position: absolute;\r\n}\r\n\r\np.footer.upper {\r\n    color: #4d4d4d;\r\n    font-size: 10px;\r\n    font-weight: 600;\r\n    letter-spacing: 0.2px;\r\n    text-transform: uppercase;\r\n}\r\n\r\nbody.cool.cool-color p.footer {\r\n    color: #ffffff;\r\n}\r\n\r\na {\r\n    color: #4769cc;\r\n    text-decoration: none;\r\n}\r\n\r\na:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\na.strong,\r\nspan.strong {\r\n    background-color: #dbe9f4;\r\n    padding: 2px 4px 2px 4px;\r\n}\r\n\r\na.button,\r\nspan.button {\r\n    background-color: #2d9fc4;\r\n    border-radius: 4px 4px 4px 4px;\r\n    color: #ffffff;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    height: 34px;\r\n    letter-spacing: 1px;\r\n    line-height: 34px;\r\n    margin: 0px 0px 0px 0px;\r\n    min-width: 120px;\r\n    text-transform: uppercase;\r\n    transition: color 0.1s linear, background-color 0.1s linear;\r\n    user-select: none;\r\n}\r\n\r\na.button:hover,\r\nspan.button:hover {\r\n    background-color: #31acd4;\r\n    text-decoration: none;\r\n}\r\n\r\na.button:active,\r\nspan.button:active {\r\n    background-color: #2c99bd;\r\n}\r\n\r\na.button.button-small,\r\nspan.button.button-small {\r\n    font-size: 10px;\r\n    height: 30px;\r\n    line-height: 30px;\r\n}\r\n\r\na.button.button-green,\r\nspan.button.button-green {\r\n    background-color: #64a280;\r\n}\r\n\r\na.button.button-grey,\r\nspan.button.button-grey {\r\n    background-color: #2d2d2d;\r\n}\r\n\r\na.button.button-grey:hover,\r\nspan.button.button-grey:hover {\r\n    background-color: #4d4d4d;\r\n}\r\n\r\na.button.button-grey:active,\r\nspan.button.button-grey:active {\r\n    background-color: #1d1d1d;\r\n}\r\n\r\na.button.button-transparent,\r\nspan.button.button-transparent {\r\n    background-color: transparent;\r\n    border: 1px solid #ffffff;\r\n}\r\n\r\na.button-transparent:hover,\r\nspan.button-transparent:hover {\r\n    background-color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\na.button-transparent:active,\r\nspan.button-transparent:active {\r\n    background-color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\nhr {\r\n    margin: 3px 0px 3px 0px;\r\n}\r\n\r\ntable {\r\n    font-size: 13px;\r\n    line-height: 18px;\r\n    max-width: 760px;\r\n    table-layout: fixed;\r\n    word-break: break-all;\r\n}\r\n\r\ntable th {\r\n    font-weight: 600;\r\n}\r\n\r\ntable th > *,\r\ntable td > * {\r\n    vertical-align: middle;\r\n}\r\n\r\ntable th > a {\r\n    color: #2d2d2d;\r\n}\r\n\r\ntable th > a.selected {\r\n    font-weight: bold;\r\n    text-decoration: underline;\r\n}\r\n\r\ntable td > svg {\r\n    color: #4d4d4d;\r\n    fill: currentcolor;\r\n    margin-right: 6px;\r\n}\r\n\r\n.buttons {\r\n    margin: 16px 0px 16px 0px;\r\n}\r\n\r\n.highlight {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    margin: 12px 0px 12px 0px;\r\n}\r\n\r\n.highlight > a {\r\n    background: #f4f4f4;\r\n    box-shadow: 1px 1px 4px rgba(80, 80, 80, 0.35);\r\n    display: inline-block;\r\n    padding: 8px 16px 8px 16px;\r\n}\r\n\r\n.traceback {\r\n    line-height: 26px;\r\n    margin: 8px 0px 8px 0px;\r\n}\r\n\r\n.container {\r\n    animation: fade-into 0.75s ease-in-out;\r\n    width: 100%;\r\n}\r\n\r\nbody.cool .container {\r\n    animation: fade-grow 0.5s ease-in-out;\r\n    background-color: #ffffff;\r\n    border: 1px solid #d4d4d4;\r\n    border-radius: 4px 4px 4px 4px;\r\n    box-shadow: 0px 0px 3px #e4e4e4;\r\n    margin: 12px auto 12px auto;\r\n    padding: 24px 42px 24px 42px;\r\n    width: auto;\r\n}\r\n\r\nbody.cool .container.dynamic {\r\n    padding: 24px 0px 24px 0px;\r\n    width: 100%;\r\n}\r\n\r\nbody.cool.cool-color .container {\r\n    background-color: #fefefe;\r\n    border: none;\r\n    box-shadow: 0px 0px 24px rgba(10, 10, 10, 0.4);\r\n}\r\n\r\n.container img.logo {\r\n    max-height: 128px;\r\n    max-width: 128px;\r\n}\r\n\r\n@media screen and (max-width: 760px) {\r\n\r\n    table th,\r\n    table td {\r\n        display: none;\r\n    }\r\n\r\n    table td:nth-child(1) {\r\n        display: initial;\r\n    }\r\n\r\n    body.cool .container {\r\n        padding: 12px 12px 12px 12px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
